module.exports = __webpack_public_path__ + "static/media/logOut.3727c74d.svg";